// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import '../lib/player-cdn.css'
import 'vuejs-dialog/dist/vuejs-dialog.min.css';
import Vuex from 'vuex'
Vue.use(Vuex)
import store from './store/index';
import VueI18n from 'vue-i18n';
import i18n from './i18n/index';
import VuejsDialog from "vuejs-dialog"


const PlayerCdn = process.env.NODE_ENV === 'development'
    ? require('../src/player-cdn.js')
    : require('../lib/player-cdn.js')

Vue.use(VueI18n)
Vue.use(VuejsDialog)
Vue.config.productionTip = false
Vue.use(PlayerCdn.default)
new Vue({
    el: '#app',
    i18n,
    router,
    store,
    template: '<App/>',
    components: {App}
})



// WEBPACK FOOTER //
// ./demo/main.js